import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

export default function CollectionDialog({
  title,
  children,
  pending,
  onClose,
}) {
  const titleId = React.useId();
  return (
    <Dialog
      open
      onClose={(_, reason) => {
        if (!pending && reason !== "backdropClick") onClose();
      }}
      aria-labelledby={titleId}
      slotProps={{
        paper: {
          "aria-busy": pending,
          tabIndex: -1,
          sx: {
            maxWidth: 420,
            bgcolor: "background.default",
            backgroundImage: "none",
          },
        },
      }}
    >
      <DialogTitle id={titleId}>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
